import React, { useState } from 'react';
import axios from 'axios';

const ComplaintStatus = () => {
  const [beneficiaryId, setBeneficiaryId] = useState('');
  const [complainId, setComplainId] = useState('');
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.post('http://88.321.245.91:8004/admin/show-data', {
        beneficiaryId,
        complainId
      });
      
      setStatusData(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch complaint status');
      console.error('Error fetching complaint status:', err);
    } finally {
      setLoading(false);
    }
  };

  return (<div className="max-w-xl mx-auto p-6 bg-white shadow-md rounded-lg">
  <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Complaint Status</h2>

  <form onSubmit={handleSubmit} className="space-y-4">
    <div className="flex flex-col">
      <label htmlFor="beneficiaryId" className="mb-1 text-sm font-medium text-gray-700">
        Beneficiary ID
      </label>
      <input
        type="text"
        id="beneficiaryId"
        className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={beneficiaryId}
        onChange={(e) => setBeneficiaryId(e.target.value)}
        placeholder="Enter Beneficiary ID"
        required
      />
    </div>

    <div className="flex flex-col">
      <label htmlFor="complainId" className="mb-1 text-sm font-medium text-gray-700">
        Complaint ID
      </label>
      <input
        type="text"
        id="complainId"
        className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={complainId}
        onChange={(e) => setComplainId(e.target.value)}
        placeholder="Enter Complaint ID"
        required
      />
    </div>

    <button
      type="submit"
      className="w-full bg-yellow-400 text-white font-semibold py-2 rounded-md hover:bg-yellow-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      disabled={loading}
    >
      {loading ? 'Checking...' : 'Check Status'}
    </button>
  </form>

  {loading && (
    <p className="mt-4 text-blue-600 font-medium text-center animate-pulse">Loading...</p>
  )}

  {error && (
    <p className="mt-4 text-red-600 text-sm font-medium text-center">{error}</p>
  )}

  {statusData && (
    <div className="mt-6 bg-gray-100 p-4 rounded-md">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">Complaint Status Details</h3>
      <pre className="text-sm text-gray-700 whitespace-pre-wrap">
        {JSON.stringify(statusData, null, 2)};
        </pre>
    </div>
    )}
</div>
    );
    
};

export default ComplaintStatus;